import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LegalEntityQueryKey } from './queryKey';
export const useUpdateLegalEntity = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base
        .put(`/api/legalentity/${model.id}`, model)
        .then(res => res.data), {
        onSuccess: (result) => {
            if (!result)
                return;
            queryClient.setQueryData([LegalEntityQueryKey.LegalEntities], old => old ? old.map(e => (e.id === result.id ? result : e)) : old);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateLegalEntity: mutateAsync, isLoading };
};
